import { z } from 'zod'; // Add new import

export const TimesheetGlobalSchema = z.object({
  month: z.number({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
  year: z.number({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
  details: z.boolean({
    required_error: 'fieldRequired',
    invalid_type_error: 'fieldRequired',
  }),
  isEmployee: z
    .boolean({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    })
    .optional()
    .nullable(),
  resourceId: z
    .number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    })
    .optional()
    .nullable(),
  customerId: z
    .number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    })
    .optional()
    .nullable(),
  jobId: z
    .number({
      required_error: 'fieldRequired',
      invalid_type_error: 'fieldRequired',
    })
    .optional()
    .nullable(),
});
